import { render, staticRenderFns } from "./assignPhone.vue?vue&type=template&id=72ff769f&scoped=true&"
import script from "./assignPhone.vue?vue&type=script&lang=ts&"
export * from "./assignPhone.vue?vue&type=script&lang=ts&"
import style0 from "./assignPhone.vue?vue&type=style&index=0&id=72ff769f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff769f",
  null
  
)

export default component.exports